import React from 'react';
import { CheckCircle2, AlertCircle, Loader2, RotateCcw } from 'lucide-react';

// Progress / result line for one staff document upload (see hooks/useStaffDocUploads.js).
const DocUploadProgress = ({ upload, onRetry }) => {
    if (!upload) return null;

    if (upload.status === 'uploading') {
        const checking = upload.percent >= 99;
        return (
            <div className="mt-1.5 w-full" role="progressbar" aria-valuenow={upload.percent} aria-valuemin={0} aria-valuemax={100}>
                <div className="flex items-center justify-between text-[10px] font-semibold text-blue-700 dark:text-blue-300 mb-0.5">
                    <span className="flex items-center gap-1">
                        <Loader2 className="h-3 w-3 animate-spin" />
                        {checking ? 'Saving and checking the file…' : 'Uploading…'}
                    </span>
                    <span>{upload.percent}%</span>
                </div>
                <div className="h-1.5 w-full rounded-full bg-blue-100 dark:bg-blue-900/40 overflow-hidden">
                    <div className="h-full rounded-full bg-gradient-to-r from-blue-600 to-orange-500 transition-all duration-300"
                        style={{ width: `${upload.percent}%` }} />
                </div>
            </div>
        );
    }

    if (upload.status === 'done') {
        return (
            <p className="mt-1 flex items-center gap-1 text-[10px] font-semibold text-green-600 dark:text-green-400">
                <CheckCircle2 className="h-3 w-3" /> Uploaded and verified
            </p>
        );
    }

    return (
        <div className="mt-1 flex items-center gap-2 text-[10px] font-semibold text-rose-600 dark:text-rose-400">
            <AlertCircle className="h-3 w-3 shrink-0" />
            <span className="truncate">{upload.error || 'Upload failed'}</span>
            {upload.retryable && onRetry && (
                <button type="button" onClick={onRetry}
                    className="flex items-center gap-1 px-2 py-0.5 rounded-md bg-rose-50 dark:bg-rose-900/30 hover:bg-rose-100 dark:hover:bg-rose-900/50">
                    <RotateCcw className="h-3 w-3" /> Retry
                </button>
            )}
        </div>
    );
};

export default DocUploadProgress;
